
import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FaCheckCircle } from 'react-icons/fa';

import './dialogCopiarDadosContrato.css';

export const DialogCopiarDadosContrato = props => {
    const { openModal , closeModal } = props;
    const [visible, setVisible] = useState(false);
    const onHide = () => setVisible(false);
    const onShow = () => setVisible(openModal);

    useEffect(() => {
        onShow();
    }, [openModal]);

    const footer = (
        <div className="button-container">
            <Button
                label="ok"
                icon="pi pi-check"
                onClick={() => setVisible(closeModal)}
            />
        </div>
    );

    const body = (
        <div className="dialog-copiar-dados-contrato">
            <FaCheckCircle size={100} color="black" />
            <h2>Dados do último contrato copiados com sucesso!</h2>
            <h2>Por favor, confira os dados do cliente antes de prosseguir.</h2>
        </div>
    );

    return (
        <Dialog
            footer={footer}
            visible={visible}
            style={{ width: '50vw' }}
            modal
            showHeader={false}
            onHide={onHide}
        >
            {body}
        </Dialog>
    );
};